const Email = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.63237 7.00005H17.3679C17.5198 7.00005 17.667 7.02114 17.8068 7.06048L12.0175 11.4865L6.20203 7.05824C6.33936 7.02032 6.48368 7 6.63257 7L6.63237 7.00005ZM18.8409 7.93339L12.459 12.8126C12.2046 13.0146 11.8299 13.0146 11.5753 12.8126L5.16166 7.92752C5.05814 8.14193 5 8.38201 5 8.63499V15.3648C5 16.2641 5.73455 17 6.63226 17H17.3677C18.2654 17 19 16.2641 19 15.3648V8.63499C19 8.3843 18.9427 8.14606 18.8409 7.9332L18.8409 7.93339Z" fill="#ABABCC" />
        </svg>
    );
};

export default Email;
